import React, { useState } from 'react'
import PropTypes from 'prop-types'

import add from 'images/add.svg'
import disabledAddIcon from 'images/disabled-add-icon.svg'
import screenType from 'component/menuMission/screenType'
import Form from 'component/utils/Form'
import Modal from 'component/Modal/GenericModal'
import TextField from 'component/TextField'

const FIELDS = ['params', 'type']

/*eslint-disable */
const EditModal = ({
  closeModal,
  fields,
  initialValues,
  setValueToField,
  submit,
  translate,
  values,
  values: { params, type = screenType.CREATE_PERSONAL_PROFILE_TYPE },
}) => {
  const [initialDsJustification] = useState(
    initialValues.params[0].dsJustification
  )

  const disableButton = () =>
    thereAreEmptyFields() ||
    params[0].dsJustification === initialDsJustification

  const thereAreEmptyFields = () => params.some((j) => !j.dsJustification)

  const createField = (item, i) => {
    const dsJustification = item.dsJustification

    return (
      <div className='w-100' key={i}>
        <TextField
          {...fields.params.input}
          className='form-control no-change-color'
          fill
          label={translate(
            dsJustification
              ? 'missionMenu.addModal.field.dsJustification.placeholder'
              : 'justificationsPa.justificationDesc'
          )}
          maxLength={200}
          onChange={(event) => {
            const newParams = [...params]

            item.dsJustification = event.target.value

            setValueToField(fields.params.input.name, newParams)
          }}
          placeholder={translate(
            'missionMenu.addModal.field.dsJustification.placeholder'
          )}
          required
          value={dsJustification}
        />
      </div>
    )
  }

  return (
    <Modal
      buttonClass='half-w'
      cancelButtonText={translate('button.cancel')}
      center={false}
      confirmButtonText={translate(
        type === screenType.CREATE_PERSONAL_PROFILE_TYPE ||
          type === screenType.CREATE_MISSION_PROFILE_TYPE
          ? 'register_button'
          : 'save_button_label'
      )}
      isConfirmButtonDisabled={disableButton()}
      isOpen
      onCloseModal={closeModal}
      onConfirm={() => submit(values.params)}
      size='md'
      title={translate('justificationsPa.editModal.new.title.' + type)}
    >
      {params.map(createField)}

      {type === screenType.CREATE_PERSONAL_PROFILE_TYPE && (
        <div
          className={thereAreEmptyFields() ? 'add-item-disabled' : 'add-item'}
          onClick={
            thereAreEmptyFields()
              ? () => {}
              : () =>
                  setValueToField(fields.params.input.name, [
                    ...params,
                    { dsJustification: '', inInactive: 0 },
                  ])
          }
        >
          <img src={thereAreEmptyFields() ? disabledAddIcon : add} />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <div>
            <span>
              {translate('missionMenu.addModal.field.dsJustification.add')}
            </span>
          </div>
        </div>
      )}
    </Modal>
  )
}

EditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(EditModal)

export { EditModal }
